import { userStore } from '@/fsd/entities/user/model/store/useUserStore';
import { routes } from '../config/routes/routesConfig';
import { NotificationService } from '../lib/notifications';
import { ApiClient } from './ApiClient';

export const api = new ApiClient(
  String(process.env.API_URL),
  NotificationService,
  () => localStorage.getItem('token'),
  async () => {
    await userStore.handleOut();
  },
  () => {
    window.location.href = routes.tariffsAndPayments.path;
  }
);
